import React, { useContext, useEffect } from "react";
import {
  Table,
  Button,
  Row,
  Col,
  Popconfirm,
  notification,
  Modal,
  Typography,
  Space,
} from "antd";
import api from "../../api/endpoints";
import { WasteContext } from "../../containers/Waste";
import {
  DeleteFilled,
  RightCircleFilled,
  FileExcelFilled,
  MinusOutlined,
  DownloadOutlined,
  PlusOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";

const { Paragraph } = Typography;

const List = () => {
  const { state, dispatch } = useContext(WasteContext);

  async function getResidues() {
    await api.residues.list(state.list.page).then((x) => {
      dispatch({
        type: "add_residues",
        payload: x,
      });
    });
  }

  const selectResidue = (residue) => {
    dispatch({
      type: "select_to_edit",
      payload: { residue },
    });
    dispatch({ type: "set_drawer_visible", payload: true });
  };

  const deleteResidue = async (residue) => {
    const response = await api.residues.delete(residue.id).then(() => {
      dispatch({
        type: "update_list",
      });
      dispatch({
        type: "change_page",
        page: 1,
      });
      notification.success({ message: "Residuo eliminado" });
    });
  };

  const downloadDataToExcel = async () => {
    const pageSize = 10; // Número de elementos por página
    let currentPage = 1; // Página actual
    let allData = []; // Array para almacenar todos los datos

    // Función para obtener los datos de una página específica
    const getDataPage = async (page) => {
      const rq = await api.residues.list(page);
      return rq.results;
    };

    // Obtener los datos de la primera página
    let pageData = await getDataPage(currentPage);
    allData = allData.concat(pageData);

    // Obtener los datos de las páginas restantes
    while (pageData.length === pageSize) {
      currentPage++;
      pageData = await getDataPage(currentPage);
      allData = allData.concat(pageData);
    }

    // Dividir los datos en lotes más pequeños

    const filteredData = allData.map((item) => ({
      "Fecha creacion": item.created.slice(0, 10),
      Nombre: item.name,
      Medida: item.type_medition,
      Cantidad: item.quantity,
    }));

    // Crear el archivo Excel y descargarlo
    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    // Set column widths based on the length of the title text
    const columnWidths = Object.keys(worksheet).reduce((widths, cell) => {
      const column = cell.replace(/[0-9]/g, "");
      const value = worksheet[cell].v;
      const length = value ? value.toString().length : 10; // Default width if value is empty
      widths[column] = Math.max(widths[column] || 0, length);
      return widths;
    }, {});

    // Apply column widths to the worksheets
    worksheet["!cols"] = Object.keys(columnWidths).map((column) => ({
      wch: columnWidths[column],
    }));

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Clientes");

    // Función para aplicar estilos a las celdas
    const applyStyles = (worksheet, range, style) => {
      const { s, e } = XLSX.utils.decode_range(range);
      for (let row = s.r; row <= e.r; row++) {
        for (let col = s.c; col <= e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          if (!worksheet[cell]) {
            worksheet[cell] = {};
          }
          worksheet[cell].s = style;
        }
      }
    };

    // Crear estilos para las celdas
    const borderStyle = {
      border: {
        top: { style: "thin", color: { rgb: "00000000" } },
        bottom: { style: "thin", color: { rgb: "00000000" } },
        left: { style: "thin", color: { rgb: "00000000" } },
        right: { style: "thin", color: { rgb: "00000000" } },
      },
    };

    const headerStyle = {
      fill: { fgColor: { rgb: "00000000" } },
      font: { color: { rgb: "FFFFFFFF" } },
    };

    // Aplicar estilos a las celdas con datos
    applyStyles(worksheet, "A1:Z1000", borderStyle);

    // Aplicar estilo a la primera fila
    applyStyles(worksheet, "A1:Z1", headerStyle);

    XLSX.writeFile(workbook, `listado_residuos.xlsx`);
  };

  const downloadListToExcel = async (list, e) => {
    const filteredData = list.map((item) => ({
      Residuo: e.name,
      Fecha: item.created.slice(0, 10),
      Cantidad: item.quantity,
      Usuario: item.user.email,
      Observacion: item.observation,
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const columnWidths = Object.keys(worksheet).reduce((widths, cell) => {
      const column = cell.replace(/[0-9]/g, "");
      const value = worksheet[cell].v;
      const length = value ? value.toString().length : 10; // Default width if value is empty
      widths[column] = Math.max(widths[column] || 0, length);
      return widths;
    }, {});

    // Apply column widths to the worksheets
    worksheet["!cols"] = Object.keys(columnWidths).map((column) => ({
      wch: columnWidths[column],
    }));

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, `Historial de ${e.name}`);

    // Función para aplicar estilos a las celdas
    const applyStyles = (worksheet, range, style) => {
      const { s, e } = XLSX.utils.decode_range(range);
      for (let row = s.r; row <= e.r; row++) {
        for (let col = s.c; col <= e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          if (!worksheet[cell]) {
            worksheet[cell] = {};
          }
          worksheet[cell].s = style;
        }
      }
    };

    // Crear estilos para las celdas
    const borderStyle = {
      border: {
        top: { style: "thin", color: { rgb: "00000000" } },
        bottom: { style: "thin", color: { rgb: "00000000" } },
        left: { style: "thin", color: { rgb: "00000000" } },
        right: { style: "thin", color: { rgb: "00000000" } },
      },
    };

    const headerStyle = {
      fill: { fgColor: { rgb: "00000000" } },
      font: { color: { rgb: "FFFFFFFF" } },
    };

    // Aplicar estilos a las celdas con datos
    applyStyles(worksheet, "A1:Z1000", borderStyle);

    // Aplicar estilo a la primera fila
    applyStyles(worksheet, "A1:Z1", headerStyle);

    XLSX.writeFile(workbook, `historial_${e.name}.xlsx`);
    console.log(filteredData);
  };
  useEffect(() => {}, []);

  const columns = [
    {
      width: 240,
      title: "Nombre",
      dataIndex: "name",
    },
    {
      title: "Existencias",
      width: 420,
      render: (x) => {
        return (
          <Row gutter={[8, 8]} align="middle" wrap>
            <Col xs={24} sm={10}>
              {x.quantity} ({x.type_medition}){" "}
            </Col>
            <Col xs={24} sm={14}>
              <Space wrap size={[8, 8]} style={{ display: "flex", justifyContent: "flex-start" }}>
                <Button
                  size="small"
                  type="primary"
                  onClick={() =>
                    Modal.info({
                      title: `Historial de ${x.name}`,
                      icon: <HistoryOutlined />,
                      width: 800,
                      style: { top: 0 },
                      content: (
                        <>
                          <Row style={{ marginTop: `20px` }}>
                            <Col span={24}>
                              <Table
                                footer={() => (
                                  <Button
                                    type={"primary"}
                                    size="small"
                                    icon={<DownloadOutlined />}
                                    onClick={() =>
                                      downloadListToExcel(x.history_residue, x)
                                    }
                                  >
                                    Descargar listado
                                  </Button>
                                )}
                                bordered
                                size="small"
                                scroll={{ x: true }}
                                dataSource={x.history_residue}
                                columns={[
                                  {
                                    title: `Fecha`,
                                    dataIndex: `created`,
                                    render: (x) => (
                                      <>
                                        {x.slice(0, 10)} {x.slice(11, 16)} hrs
                                      </>
                                    ),
                                  },
                                  {
                                    title: `Cantidad`,
                                    dataIndex: `quantity`,
                                    render: (r) => (
                                      <>
                                        <b>{r} </b> <br />
                                      </>
                                    ),
                                  },
                                  {
                                    title: `Usuario`,
                                    dataIndex: `user`,
                                    render: (user) => (
                                      <Row>
                                        {console.log(user)}
                                        <Col>{user && user.email}</Col>
                                      </Row>
                                    ),
                                  },
                                  {
                                    title: `Procedencía`,
                                    dataIndex: `user`,
                                    render: (user) => (
                                      <Row>
                                        <Col>
                                          {user && (
                                            <>
                                              {user.type_user === `ADM`
                                                ? `Administrador`
                                                : `Bodega`}
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                    ),
                                  },
                                  {
                                    title: `Observación`,
                                    dataIndex: `observation`,
                                    render: (r) => <Paragraph>{r}</Paragraph>,
                                  },
                                ]}
                              />
                            </Col>
                          </Row>
                        </>
                      ),
                    })
                  }
                  icon={<HistoryOutlined />}
                >
                  Historial
                </Button>
                <Button
                  icon={<PlusOutlined />}
                  type="primary"
                  shape="circle"
                  size="small"
                  onClick={() => {
                    dispatch({
                      type: "select_to_add_rest",
                      payload: {
                        residue: { ...x },
                        add_quantity: true,
                        sus_quantity: false,
                      },
                    });
                    dispatch({ type: "set_drawer_visible", payload: true });
                  }}
                />
                <Button
                  icon={<MinusOutlined />}
                  type="primary"
                  shape="circle"
                  size="small"
                  onClick={() => {
                    dispatch({
                      type: "select_to_add_rest",
                      payload: {
                        residue: { ...x },
                        add_quantity: false,
                        sus_quantity: true,
                      },
                    });
                    dispatch({ type: "set_drawer_visible", payload: true });
                  }}
                />
              </Space>
            </Col>
          </Row>
        );
      },
    },
    {
      width: 220,
      render: (x) => (
        <Row justify={"space-between"} gutter={[8, 8]}>
          <Col span={24}>
            <Popconfirm
              title={"Estas seguro de eliminar el residuo?"}
              onConfirm={() => deleteResidue(x)}
            >
              <Button
                style={{ marginBottom: "5px" }}
                type="primary"
                danger
                icon={<DeleteFilled />}
                size="small"
              >
                Eliminar
              </Button>{" "}
            </Popconfirm>
          </Col>
          <Col span={24}>
            <Button
              size="small"
              type="primary"
              onClick={() => selectResidue(x)}
              icon={<RightCircleFilled />}
            >
              Editar
            </Button>
          </Col>
        </Row>
      ),
    },
  ];

  useEffect(() => {
    getResidues();
  }, [state.list.countUpdate, state.list.page]);

  return (
    <Table
      dataSource={state.list.results}
      size="small"
      scroll={{ x: true }}
      tableLayout="fixed"
      title={() => (
        <Row justify={"space-between"}>
          
          <Col>
            <Button
              style={{ backgroundColor: `#389e0d`, borderColor: `#389e0d` }}
              type={`primary`}
              size={`small`}
              icon={<FileExcelFilled />}
              onClick={downloadDataToExcel}
            >
              Descargar reporte(todos)
            </Button>
          </Col>
        </Row>
      )}
      bordered
      rowKey={(x) => x.id}
      pagination={{
        total: state.list.count,
        onChange: (page) => dispatch({ type: "change_page", page: page }),
      }}
      columns={columns}
    />
  );
};

export default List;
